import { FormControl, FormLabel, Input, InputGroup, InputLeftElement, Select, SimpleGrid, Stack } from "@chakra-ui/react";
import { Search } from "../../../shared/icons";
import { PLAN_LABEL } from "../../assinatura/lib/plan";
import { ROLE_LABEL } from "./UserBadges";

function FilterSelect({ label, value, onChange, options }) {
  return (
    <FormControl>
      <FormLabel fontSize="xs" color="app-muted-fg" mb={1}>
        {label}
      </FormLabel>
      <Select size="sm" value={value} onChange={(e) => onChange(e.target.value)} aria-label={label}>
        <option value="">Todos</option>
        {Object.entries(options).map(([key, text]) => (
          <option key={key} value={key}>
            {text}
          </option>
        ))}
      </Select>
    </FormControl>
  );
}

export default function UserFilters({ filters, onChange }) {
  const set = (key) => (value) => onChange({ ...filters, [key]: value });

  return (
    <Stack spacing={3}>
      <InputGroup size="sm">
        <InputLeftElement pointerEvents="none" color="app-muted-fg">
          <Search size={14} />
        </InputLeftElement>
        <Input
          type="search"
          placeholder="Buscar por nome ou e-mail"
          aria-label="Buscar por nome ou e-mail"
          value={filters.query}
          onChange={(e) => set("query")(e.target.value)}
        />
      </InputGroup>
      <SimpleGrid columns={{ base: 2, md: 4 }} spacing={3}>
        <FilterSelect label="Plano" value={filters.plan} onChange={set("plan")} options={PLAN_LABEL} />
        <FilterSelect
          label="Status"
          value={filters.status}
          onChange={set("status")}
          options={{ ativo: "Ativa", inativo: "Desativada" }}
        />
        <FilterSelect label="Perfil" value={filters.role} onChange={set("role")} options={ROLE_LABEL} />
        <FilterSelect
          label="E-mail"
          value={filters.verified}
          onChange={set("verified")}
          options={{ sim: "Verificado", nao: "Não verificado" }}
        />
      </SimpleGrid>
    </Stack>
  );
}
